import ExpertsAPI from '../../api/experts';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

const getters = {
  getExperts: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getExpertById: $state => id =>
    $state.records.find(e => e.id === Number(id)),
};

const mutations = {
  SET_EXPERTS($state, experts) {
    $state.records = experts;
  },
  ADD_EXPERT($state, expert) {
    $state.records.push(expert);
  },
  UPDATE_EXPERT($state, expert) {
    const idx = $state.records.findIndex(e => e.id === expert.id);
    if (idx !== -1) $state.records.splice(idx, 1, expert);
  },
  DELETE_EXPERT($state, id) {
    $state.records = $state.records.filter(e => e.id !== id);
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await ExpertsAPI.get();
      commit('SET_EXPERTS', data.payload || data);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, expertData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await ExpertsAPI.create(expertData);
      commit('ADD_EXPERT', data);
      return data;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...updateData }) {
    try {
      const { data } = await ExpertsAPI.update(id, updateData);
      commit('UPDATE_EXPERT', data);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async delete({ commit }, id) {
    try {
      await ExpertsAPI.delete(id);
      commit('DELETE_EXPERT', id);
    } catch (error) {
      throw error;
    }
  },

  async addMember({ dispatch }, { expertId, userId, role }) {
    await ExpertsAPI.addMember(expertId, { user_id: userId, role });
    dispatch('fetch');
  },

  async removeMember({ dispatch }, { expertId, userId }) {
    await ExpertsAPI.removeMember(expertId, userId);
    dispatch('fetch');
  },

  async addInbox({ dispatch }, { expertId, inboxId }) {
    await ExpertsAPI.addInbox(expertId, inboxId);
    dispatch('fetch');
  },

  async removeInbox({ dispatch }, { expertId, inboxId }) {
    await ExpertsAPI.removeInbox(expertId, inboxId);
    dispatch('fetch');
  },
};

export default { namespaced: true, state, getters, mutations, actions };
